// TO DO (bcdirito):
// Refactor all references to this route to use the constant
export const CANVAS_INTEGRATION_PATH = "/teacher/khanmigo-tools-canvas";
